import { render, staticRenderFns } from "./TemplateKurzveranstaltungsliste.vue?vue&type=template&id=18813f2d&"
import script from "./TemplateKurzveranstaltungsliste.vue?vue&type=script&lang=js&"
export * from "./TemplateKurzveranstaltungsliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports